import { adapter } from "@/services/db";

const now = () => new Date().toISOString();

export const catStatus = (c) => {
  if (c.status === "blocked" || c.is_active === false) return "blocked";
  if (c.scheduled_end_at && new Date(c.scheduled_end_at) <= new Date()) return "ended";
  return "active";
};

export async function logCat(user, id, action, extra = {}) {
  const t = now();
  await adapter.add("activity_logs", {
    app: "ops", entity_type: "categories", entity_id: id, action, change_type: action,
    performed_by: user?.email || null, performed_by_role: user?.role || null, changed_by: user?.email || null,
    status: "applied", created_at: t, server_ts: t, ...extra,
  }).catch((e) => console.warn("category log", e.code));
}

// Fields brugo-web should rely on: status ("active"|"blocked") + is_active (bool), kept in sync.
export async function createCategory(user, data) {
  const t = now();
  const doc = await adapter.add("categories", {
    ...data, status: "active", is_active: true, active_from: t, created_at: t, updated_at: t,
    created_by: user?.email || null, blocked_at: null, blocked_reason: null, ended_at: null,
  });
  await logCat(user, doc.id, "category_created", { description: `${data.name} added`, after: JSON.stringify(data) });
  return doc.id;
}

export async function updateCategory(user, c, input) {
  const { status, is_active, ...data } = input;
  await adapter.update("categories", c.id, { ...data, updated_at: now(), updated_by: user?.email || null });
  await logCat(user, c.id, "category_edited", { description: `${data.name} edited`, before: JSON.stringify({ name: c.name, description: c.description, subcategories: c.subcategories, display_order: c.display_order, scheduled_end_at: c.scheduled_end_at || null }), after: JSON.stringify(data) });
}

export async function blockCategory(user, c, reason) {
  const t = now();
  await adapter.update("categories", c.id, { status: "blocked", is_active: false, blocked_at: t, blocked_by: user?.email || null, blocked_reason: reason, updated_at: t });
  await logCat(user, c.id, "category_blocked", { description: `${c.name} blocked`, reason });
}

export async function unblockCategory(user, c, reason) {
  const t = now();
  await adapter.update("categories", c.id, { status: "active", is_active: true, active_from: t, blocked_at: null, blocked_by: null, blocked_reason: null, ended_at: null, scheduled_end_at: c.scheduled_end_at && new Date(c.scheduled_end_at) <= new Date() ? null : c.scheduled_end_at || null, updated_at: t });
  await logCat(user, c.id, "category_unblocked", { description: `${c.name} unblocked`, reason: reason || null });
}

export async function deleteCategory(user, c, reason) {
  await logCat(user, c.id, "category_deleted", { description: `${c.name} deleted`, reason: reason || null, before: JSON.stringify({ name: c.name, subcategories: c.subcategories }) });
  await adapter.remove("categories", c.id);
}

// Requests/pros still referencing the category (delete is refused if any).
export const categoryUsage = (c, requests, pros) => {
  const ids = [c.id], names = [String(c.name || "").toLowerCase()];
  const hit = (v) => (Array.isArray(v) ? v.some(hit) : ids.includes(v) || names.includes(String(v || "").toLowerCase()));
  return {
    requests: requests.filter((r) => hit(r.service_category_ids) || hit(r.category_ids) || hit(r.category)).length,
    pros: pros.filter((p) => hit(p.category_id) || hit(p.category_ids) || hit(p.category_name)).length,
  };
};
